module.exports = __webpack_public_path__ + "img/image_gateway_c300eos.a0c08fe5.svg";